import React from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({
    isOpen,
    show,
    onClose,
    onConfirm,
    childName,
    title = 'Slet ',
    warningBadgeText = 'HANDLING PÅKRÆVET',
    message,
    subMessage = 'Denne handling kan ikke fortrydes.',
    confirmText = 'Slet',
    cancelText = 'Annuller'
}) => {
    const isVisible = isOpen ?? show;
    if (!isVisible) return null;

    const primaryMessage = message || (childName ? `Er du sikker på, at du vil slette ${childName}?` : 'Er du sikker på, at du vil slette?');

    return (
        <div className="delete-modal-overlay" role="dialog" aria-modal="true">
            <div className="delete-modal-card">
                <div className="delete-modal-header">
                    <div className="delete-modal-badge">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path
                                d="M12 2.75L2.25 19.5C2.08 19.8 2 20.14 2 20.5C2 21.33 2.67 22 3.5 22H20.5C21.33 22 22 21.33 22 20.5C22 20.14 21.92 19.8 21.75 19.5L12 2.75Z"
                                fill="#ea580c"
                            />
                            <rect x="11" y="9" width="2" height="5.5" rx="1" fill="#ffffff" />
                            <circle cx="12" cy="17.5" r="1.1" fill="#ffffff" />
                        </svg>
                        <span>{warningBadgeText}</span>
                    </div>

                    <button
                        type="button"
                        className="delete-modal-close"
                        onClick={onClose}
                        aria-label="Luk"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                <h3 className="delete-modal-title">{title} {childName}?</h3>

                <div className="delete-modal-message">
                    <p className="delete-modal-primary-text">{primaryMessage}</p>
                    {subMessage && (
                        <p className="delete-modal-secondary-text">{subMessage}</p>
                    )}
                </div>

                <div className="delete-modal-actions">
                    <button
                        type="button"
                        className="delete-modal-cancel-btn"
                        onClick={onClose}
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        className="delete-modal-confirm-btn"
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
